/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog';
import InputAdornment from '@material-ui/core/InputAdornment';

import { ZoomIn , ZoomOut, KeyboardArrowRight, KeyboardArrowLeft, Fullscreen, FullscreenExit ,CloudDownload} from '@material-ui/icons'

import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import toPx from 'unit-to-px'
import { Input, TextField, Tooltip, InputBase } from '@material-ui/core';
import Action from "../../../../../fluid/Actions/ActionFactory";

import Attachment from '../JSON/components/Attachment'

import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


// const highlightPattern = (text, pattern) => {
//     const splitTextArr =  pattern.map((element) => {
//         return text.split(element);
//     })
//     if (splitTextArr.length <= 1) {
//         return text;
//     }
//     const matches = pattern.map((element) => {
//         return text.match(element)
//     })
    
  
//     return splitTextArr.reduce((arr, element, index) => (matches[index] ? [
//       ...arr,
//       element,
//       <mark style ={{backgroundColor : 'rgba(0, 253,142, 0.5)', color: 'rgba(0,0,0,0)'}}>
//         {matches[index]}
//       </mark>,
//     ] : [...arr, element]), []);
//   };


class PDFViewer extends Component {
    state = {
        numPages: null,
        pageNumber: null,
        pageNumberVar : null,
        containerWidth : 0,
        open: false,
        searchText: 'LAN',
        nav_prev_disabled : false,
        nav_next_disabled : false,
        disableFullScreen: false,
        ishighlightOn: false,
        download: false,
        file : null
    }

    componentWillMount () {
        console.log('PDF Viewer Height', this.props.height)
        console.log('PDF Viewer Width', this.props.width)
        console.log("this props for pdf viewr : ", this.props)
        let { params } = this.props;
        //let ishighlightOn = params.find((element) => element.key === 'highlight').value.boolean;
        let download = false;
        if( params.find((element) => element.key === 'download') ) {
            download  = params.find((element) => element.key === 'download').value.boolean;
        }
      
        this.setState({
            pageNumber: parseInt(this.props.pageNumber),
            pageNumberVar : parseInt(this.props.pageNumber),
            containerWidth : this.props.width,
            searchText: this.props.search_string,
            ishighlightOn: false,
            download: download,
            file : {
                url : this.props.src,
                httpHeaders : {
                    'Authorization' : JSON.parse(localStorage.getItem("auth_token"))
                }
            }
        })
    }

    componentDidUpdate (prevProps) {
        if (parseInt(prevProps.pageNumber) !== parseInt(this.props.pageNumber)) {
            this.setState({
                ...this.state,
                pageNumber : parseInt(this.props.pageNumber),
                pageNumberVar : parseInt(this.props.pageNumber)
            })
        }

        if (prevProps.width !== this.props.width) {
            this.setState({
                ...this.state,
                containerWidth : this.props.width
            })
        }
    }


    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages, disableFullScreen: false });
    }

    onDocumentLoadError = () => {
        this.setState({ disableFullScreen: true})
    }

    zoomIn = () => {
        this.setState({
            containerWidth: this.state.containerWidth + 100
        }, () => {
            this.removeTextLayerOffset()
        })
    }

    zoomOut = () => {
        this.setState({
            containerWidth: this.state.containerWidth - 100
        }, () => {
            this.removeTextLayerOffset()
        })
    }

    nextPage = () => {
        if( this.state.pageNumber != this.state.numPages){
            this.setState({
                pageNumber : this.state.pageNumber + 1,
                pageNumberVar : this.state.pageNumber + 1
            })
        }
        
    }

    prevPage = () => {
        if(this.state.pageNumber != 1 ){
            this.setState({
                pageNumber : this.state.pageNumber - 1,
                pageNumberVar : this.state.pageNumber - 1
            })
        }
        
    }

    removeTextLayerOffset = () => {
        const textLayers = document.querySelectorAll(".react-pdf__Page__textContent");
            textLayers.forEach(layer => {
                const { style } = layer;
                // style.width = toPx('vw') * 100;
                style.top = "0";
                style.left = "0";
                style.transform = "";
            });
    }

    makeTextRenderer = (searchText) => {
        return (textItem) => {
            // if(searchText == '' || searchText == undefined || typeof(searchText) == undefined){
            //     return (
            //         <div>{textItem.str}</div>
            //     )
            // } else {
            //     return this.highlightPattern(textItem.str, searchText)
            // }


            if( this.state.ishighlightOn) {
                if (searchText === "") {
                    return (
                        <div>{textItem.str}</div>
                    )
                } else {
                    return this.highlightPattern(textItem.str, searchText)
                }
            } else {
                return (
                    <div>{textItem.str}</div>
                )
            }
            
        };
    }

    highlightPattern = (text, pattern) => {
        let searchTerms = pattern.split(" ");
        let splitText = text;
        let splitTextByTerms = [];
        for( let term = 0; term < searchTerms.length; term++ ){
            let searchTerm = searchTerms[term];
            let splitByTerm = splitText.split(searchTerm);
            let markedText = this.getMarkedText(splitByTerm, searchTerm);
            splitText = markedText;
        }

        return (
            <Fragment>
                {
                    <div dangerouslySetInnerHTML={{__html:splitText}}></div>
                }
            </Fragment>
        )
    };


    getMarkedText = (splitArr, term) => {
        // return splitArr.map((ea, i) => {
        //             if(ea.toLowerCase() === term.toLowerCase()){
        //             return <mark key={`match${i}`} className="Search-suggestions-match">{ea}</mark>
        //             } else {
        //             return ea;
        //             }
        let markedText = `<mark key={splitArr+term} style='background-color:rgba(0, 253,142, 0.5); color: rgba(0,0,0,0)' dangerouslySetInnerHTML={{__html:${term}}}>${term}</mark>`
        console.log("PDFViewer :: Split Array :", splitArr)
        return splitArr.reduce(function(accumulator, currentValue, currentIndex, array){
            return accumulator  +  markedText + currentValue
        })
    }

    handlePage = (event) => {
        if (event.target.value !== "") {
            this.setState({
                pageNumberVar: parseInt(event.target.value)
            })
        } else {
            this.setState({
                pageNumberVar: event.target.value
            })
        }
    }

    setPage = () => {
        console.log('Setting Page: ')
        this.setState({
            ...this.state,
            pageNumber : this.state.pageNumberVar
        })
    }



    downloadFile = () => {
        Action('http_request', {
            url : this.props.downloadUrl,
            method : 'get',
            responseType : 'blob'
        }).then(response => {
            console.log("Download Response : ", response)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.props.filename); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).catch(err => {

        })
       
    }

    switchFullScreen = () => {
        this.setState({
            open: !this.state.open
        })
    }

    renderFullScreen = () => {
        return (
            <Dialog fullScreen open={this.state.open}>
                <div style = {{
                    width: '100vw', 
                    height: '100vh',
                    backgroundColor: '#F0F0F0',
                    display:'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} >
                    <Paper style = {{
                        width: '100vw', 
                        height: '50px', 
                        backgroundColor: '#FFFFFF',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}
                    square
                    >   
                        <Typography style = {{marginLeft: '5px', flexGrow: 1}} variant = 'overline'>{this.props.filename}</Typography>
                        <div style = {{
                            display: 'flex', 
                            marginLeft: '15px', 
                            marginRight: '10px',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                           <Input style = {{marginLeft: '5px'}}
                                size = 'small'
                                display = 'inline' 
                                margin = 'none'
                                error = {this.state.pageNumberVar > this.state.numPages ? true : false}
                                value = {this.state.pageNumberVar}
                                inputProps={{
                                    style: {fontSize: 12, maxWidth: '50px', textAlign: 'center'}
                                }}
                                endAdornment = {<InputAdornment style = {{fontSize: 12}} position="end">/ {this.state.numPages}</InputAdornment>}
                                onChange = {(event) => this.handlePage(event)}
                                onKeyDown = {(event) => {
                                    if (event.keyCode === 13) {
                                        if (this.state.pageNumberVar <= this.state.numPages && this.state.pageNumberVar > 0) {
                                            this.setPage()
                                        }
                                    }
                                }}
                            ></Input>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.prevPage} disabled = {this.state.pageNumber === 1 ? true : false}>
                                    <KeyboardArrowLeft></KeyboardArrowLeft>
                                </IconButton>
                                <IconButton size = 'small' onClick = {this.nextPage} disabled = {this.state.pageNumber === this.state.numPages ? true : false}>
                                    <KeyboardArrowRight></KeyboardArrowRight>
                                </IconButton>
                            </div>
                        </div>
                        <div style = {{marginLeft: '15px', marginRight: '10px'}}>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                {
                                    this.state.download === true && (
                                        <IconButton 
                                            size = 'small'
                                            onClick={(event) => { event.preventDefault(); this.downloadFile()}}
                                            // href = {this.props.downloadUrl}
                                            // target="_blank"
                                            // download = {this.props.filename}
                                        >
                                            <CloudDownload></CloudDownload>
                                        </IconButton>
                                    )
                                }
                                <IconButton size = 'small' onClick = {this.switchFullScreen}>
                                    <FullscreenExit></FullscreenExit>
                                </IconButton>
                                
                               
                            </div>
                        </div>
                    </Paper>
                    <div style = {{
                        width: '100%',
                        margin:'10px',
                        overflow: 'auto',
                        boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.19)'
                    }}>
                        <Document
                        file={this.state.file}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        onLoadError={this.onDocumentLoadError}
                        >
                            <Page 
                            renderMode = "canvas" 
                            renderTextLayer = {true} 
                            width = {toPx('vw') * 100} 
                            pageNumber={this.state.pageNumber}
                            onLoadSuccess={this.removeTextLayerOffset}
                            //customTextRenderer = {(textItem) => this.makeTextRenderer(this.state.searchText)}
                            customTextRenderer={ 
                                ( this.state.searchText !== '' || this.state.searchText !== undefined ) 
                                && this.makeTextRenderer(this.state.searchText)
                            }
                            />
                        </Document>
                    </div>
                </div>
            </Dialog>
        )
    }

    render() {
        console.log('PDF Viewer Props: ', this.props)
        return (
            <Fragment>
                <div style = {{
                    width: this.props.width, 
                    height: this.props.height,
                    display:'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor : '#757575'
                }} >
                    <Paper style = {{
                        width: this.props.width, 
                        height: '50px', 
                        backgroundColor: '#FFFFFF',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}
                    square
                    >   <Tooltip title = {this.props.filename}>
                            <Typography style = {{
                                width: '20%',
                                flexGrow: 1
                            }} 
                            variant = 'overline' 
                            noWrap = {true}
                            >{this.props.filename}</Typography>
                        </Tooltip>
                        <div style = {{
                            flexGrow: 1,
                            display: 'flex', 
                            marginLeft: '5px', 
                            marginRight: '10px',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Input style = {{marginLeft: '5px'}}
                                size = 'small'
                                display = 'inline' 
                                margin = 'none'
                                error = {this.state.pageNumberVar > this.state.numPages ? true : false}
                                value = {this.state.pageNumberVar}
                                inputProps={{
                                    style: {fontSize: 12, maxWidth: '50px', textAlign: 'center'}
                                }}
                                endAdornment = {<InputAdornment style = {{fontSize: 12}} position="end">/ {this.state.numPages}</InputAdornment>}
                                onChange = {(event) => this.handlePage(event)}
                                onKeyDown = {(event) => {
                                    if (event.keyCode === 13) {
                                        if (this.state.pageNumberVar <= this.state.numPages && this.state.pageNumberVar > 0) {
                                            this.setPage()
                                        }
                                    }
                                }}
                            ></Input>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.prevPage} disabled = {this.state.pageNumber === 1 ? true : false}>
                                    <KeyboardArrowLeft></KeyboardArrowLeft>
                                </IconButton>
                                <IconButton size = 'small' onClick = {this.nextPage} disabled = {this.state.pageNumber === this.state.numPages ? true : false}>
                                    <KeyboardArrowRight></KeyboardArrowRight>
                                </IconButton>
                            </div>
                        </div>
                        <div style = {{marginLeft: '15px', marginRight: '10px'}}>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.zoomIn}>
                                    <ZoomIn></ZoomIn>
                                </IconButton>
                                <IconButton size = 'small' onClick = {this.zoomOut}>
                                    <ZoomOut></ZoomOut>
                                </IconButton>
                            </div>
                        </div>
                        
                        <div style = {{marginLeft: '15px', marginRight: '10px'}}>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                {
                                    this.state.download === true && (
                                        <IconButton 
                                            size = 'small'
                                            onClick={(event) => { event.preventDefault(); this.downloadFile()}}
                                            // href = {this.props.downloadUrl}
                                            // target="_blank"
                                            // download = {this.props.filename}
                                        >
                                            <CloudDownload></CloudDownload>
                                        </IconButton>
                                    )
                                }
                                <IconButton size = 'small' 
                                    disabled = {this.state.disableFullScreen === true ? true : false}
                                    onClick = {this.switchFullScreen}>
                                    <Fullscreen></Fullscreen>
                                </IconButton>
                                {
                                    this.props.re_attach && (
                                        <div style = {{width : '50px'}}>
                                            <Attachment
                                                width = '100%%'
                                                attachment = {this.props.attachment_object}
                                                show_title = {false}
                                                show_view = {false}
                                                server_name = {this.props.attachment_object.file_wv_address.wv_server_name}
                                                file_id = {this.props.attachment_object.file_wv_address.wv_id}
                                                file_name = {this.props.attachment_object.file_name}
                                                file_type = {'PDF'}
                                                path = {'PDF'}
                                                record = {this.props.record}
                                                drl_url = {this.props.drl_url}
                                                re_attach = {this.props.re_attach}
                                                attach_options = {this.props.attach_options}
                                                re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                           
                        
                    </Paper>
                    <div style = {{
                        width: this.state.containerWidth,
                        maxWidth: this.props.width,
                        padding: '10px',
                        //marginTop:'10px',
                        height: 'calc('+ this.props.height + 'px - 50px)', 
                        overflow: 'auto',
                        boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.19)',
                        display : 'flex',
                        flexDirection : 'row',
                        justifyContent : 'center',
                        // alignItems : 'center',
                    }}>
                        <div style = {{boxShadow : "0px 6px 20px 0px rgba(0,0,0,0.4)"}}>
                            <Document
                            file={this.state.file}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            onLoadError={this.onDocumentLoadError}
                            loading = {<div style = {{
                                width : this.state.containerWidth + 'px', 
                                height : 'calc('+ this.props.height + 'px - 50px)',
                                display : 'flex',
                                flexDirection : 'row',
                                justifyContent : 'center',
                                alignItems : 'center'
                            }}>
                                <Typography style = {{color : '#FFFFFF'}} variant = 'caption'>{"Loading " + this.props.file_type.toUpperCase()}</Typography>
                            </div>}
                            >
                                <Page 
                                renderMode = "canvas" 
                                renderTextLayer = {true} 
                                width = {this.state.containerWidth - 50} 
                                pageNumber={this.state.pageNumber}
                                onLoadSuccess={this.removeTextLayerOffset}
                                customTextRenderer={ 
                                    ( this.state.searchText !== '' || this.state.searchText !== undefined ) 
                                    && this.makeTextRenderer(this.state.searchText)
                                }
                                // customTextRenderer = {(textItem) => this.makeTextRenderer(this.state.searchText)}
                                loading = {
                                    <div style = {{
                                        width : this.state.containerWidth + 'px', 
                                        height : 'calc('+ this.props.height + 'px - 50px)',
                                        display : 'flex',
                                        flexDirection : 'row',
                                        justifyContent : 'center',
                                        alignItems : 'center'
                                    }}>
                                        <Typography style = {{color : '#FFFFFF'}} variant = 'caption'>{"Loading Page " + this.state.pageNumber}</Typography>
                                    </div>
                                }
                                />
                            </Document>
                        </div>
                    </div>
                </div>
                {this.renderFullScreen()}
            </Fragment>
        );
    }
}

export default PDFViewer;